import { asyncRouter, defaultRouter } from '@/router'
import { filterAsyncRoutes } from '@/utils'
import { getDocmenuList } from '@/api/docmenu'
import { getNTCConfig } from '@/api/notice'
import MainLayout from '@/components/MainLayout'

const state = {
  name: '',
  routes: '',
  docRoutes: '',
  ntcRole: '',
  roleLoaded: false
}

const mutations = {
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_ROUTES: (state, routes) => {
    const r = defaultRouter.concat(routes)
    state.routes = r
  },
  SET_DOC_ROUTES: (state, routes) => {
    const r = state.routes.concat(routes)
    state.docRoutes = r
  },
  SET_NTC_ROLE: (state, ntcRole) => {
    state.ntcRole = ntcRole
    state.roleLoaded = true
  }
}

const actions = {
  // 拉取用户信息与权限配置（一次请求同时获取 username 与 ntc_role）
  getInfo({ commit }) {
    return getNTCConfig().then(res => {
      commit('SET_NAME', res?.data?.username || 'testuser')
      commit('SET_NTC_ROLE', res?.data?.role || '')
    })
  },
  // 路由级权限统一按 ntc_role 过滤（见 src/utils/permission.js），无需再请求外部权限服务
  generateRoutes({ commit }) {
    return new Promise(resolve => {
      const accessedRoutes = filterAsyncRoutes(asyncRouter)
      commit('SET_ROUTES', accessedRoutes)
      resolve(defaultRouter.concat(accessedRoutes))
    })
  },
  getDocMenu({ commit }) {
    return new Promise(resolve => {
      getDocmenuList().then(res => {
        const levelObj = { 1: [], 2: [], 3: [] }
        res.data.map(x => {
          levelObj[x.level].push({
            path: `${x.type === 'doc' ? `/DocumentView/${x.id}` : `/${x.menu_title}`}`,
            meta: { name: x.menu_title, icon: 'profile' },
            id: x.id,
            parent_id: x.parent_id,
            type: x.type
          })
        })
        levelObj[2] = findFatherMethod(levelObj[2], levelObj[3])
        levelObj[1] = findFatherMethod(levelObj[1], levelObj[2])
        const treeData = [
          {
            path: `/AllDoc`,
            meta: { name: '全部文档', icon: 'snippets' },
            type: 'menu',
            component: MainLayout,
            children: levelObj[1]
          }
        ]
        commit('SET_DOC_ROUTES', treeData)
        resolve(treeData)
      })
    })
  }
}

function findFatherMethod(father, children) {
  father.map(x => {
    children.map(y => {
      if (y.parent_id === x.id) {
        x.children ? x.children.push(y) : (x.children = [y])
      }
    })
  })
  return father
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
